import PropTypes from 'prop-types'
import { formatearFecha } from '../../helpers/dateValidation'
import InputLabel from '../ui/InputLabel'

const FORMATO_INPUT_DATE = 'YYYY-MM-DD'

const FechaPublicacion = ({ publicacion, onChange, vieneDeAdministrar }) => {
  const fechaDesdeFormateada = formatearFecha(publicacion.desde, FORMATO_INPUT_DATE)
  const fechaHastaFormateada = formatearFecha(publicacion.hasta, FORMATO_INPUT_DATE)
  const disabledInputFecha = Boolean(publicacion.idListaVenta)

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Indica desde qué fecha quieres que tu producto esté disponible al público.
        </p>
      )}
      <div className="row d-none d-md-block">
        <div className="col mb-3">
          <InputLabel
            type="date"
            name="desde"
            value={fechaDesdeFormateada}
            classNameInput="input-text-bordered w-40"
            onChange={onChange}
            label="Fecha desde: "
            error="Completar Fecha desde"
            disabled={disabledInputFecha}
          />
        </div>
        <div className="col">
          <InputLabel
            type="date"
            name="hasta"
            value={fechaHastaFormateada}
            classNameInput="input-text-bordered w-40"
            onChange={onChange}
            label="Fecha hasta: "
            error="Completar Fecha hasta"
            disabled={disabledInputFecha}
          />
        </div>
        {vieneDeAdministrar && <div className="col" />}
      </div>
      <div className="row d-block d-md-none">
        <div className="col-12">
          <InputLabel
            type="date"
            name="desde"
            value={fechaDesdeFormateada}
            classNameInput="input-text-bordered w-30"
            onChange={onChange}
            label="Fecha desde: "
            error="Completar Fecha desde"
            disabled={disabledInputFecha}
          />
        </div>
        <div className="col-12">
          <InputLabel
            type="date"
            name="hasta"
            value={fechaHastaFormateada}
            classNameInput="input-text-bordered w-30"
            onChange={onChange}
            label="Fecha hasta: "
            error="Completar Fecha hasta"
            disabled={disabledInputFecha}
          />
        </div>
        {vieneDeAdministrar && <div className="col" />}
      </div>
      <p className="warningMessage">
        En caso de seleccionar una lista de venta se utilizará esa vigencia.
      </p>
    </>
  )
}

FechaPublicacion.propTypes = {
  publicacion: PropTypes.shape({
    desde: PropTypes.string,
    hasta: PropTypes.string,
    idListaVenta: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default FechaPublicacion
